import { CustomFormField } from './CustomFormField';
import { FormGroup } from 'components/form/FormGroup';
import { FormSection } from 'components/form/FormSection';
import { React } from 'libs/react';
import './CustomFormFieldGroup.scss';
/**
 * @component CustomFormFieldGroup
 * @since 1.0.0
 * @hidden
 */
export function CustomFormFieldGroup(props) {
    const { group, functionValue, hideGroupTitle, populate, onBlur, onChange, fromPublic, translable = true } = props;
    return (React.createElement(FormSection, { className: "custom-form-field-group", key: group.id, title: !hideGroupTitle ? group.title : undefined },
        React.createElement(FormGroup, null, group.fields
            .filter((field) => {
            // Afficher si le champ est actif
            if (field.active !== false)
                return true;
            // Afficher si le champ est inactif mais a une valeur
            if (field.value && field.value !== 'null' && field.value !== '{}')
                return true;
            // Sinon cacher
            return false;
        })
            .map((field) => (React.createElement(CustomFormField, { field: field, key: field.id, populate: populate, onBlur: onBlur, onChange: onChange, functionValue: functionValue, fromPublic: fromPublic, translable: translable }))))));
}
